import React from "react";

import { Progress as AntProgress, ProgressProps } from "antd";

export const Progress = ({ ...props }: ProgressProps) => (
  <AntProgress
    {...props}
    size={props.size || (props.type === "circle" ? 280 : undefined)}
    strokeWidth={props.strokeWidth || (props.type === "line" ? 20 : 10)}
  />
);

export default Progress;
